import React from 'react';

const Footer = () => {
  return (
    <footer
      style={{
        backgroundColor: '#1a1a40', // Professional dark shade
        color: '#fff',
        padding: '40px 20px',
        fontSize: '14px',
      }}
    >
      {/* Footer Container */}
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', maxWidth: '1200px', margin: '0 auto' }}>
        {/* Company Information */}
        <div style={{ flex: '1', minWidth: '250px', marginBottom: '20px' }}>
          <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>CALFIN Technologies Private Limited</h3>
          <p style={{ margin: '5px 0' }}>Unlock Your Time and Money</p>
          <p style={{ margin: '5px 0' }}>
            Plot No. 92, Road No. 4, Vasanth Nagar Colony, JNTU, Hyderabad - 500085
          </p>
          <p style={{ margin: '5px 0' }}>Phone: +91 7569523497</p>
          <p style={{ margin: '5px 0' }}>Email: <a href="mailto:info@calfin.co.in" style={{ color: '#0073e6', textDecoration: 'none' }}>info@calfin.co.in</a></p>
        </div>

        {/* Quick Links */}
        <div style={{ flex: '1', minWidth: '200px', marginBottom: '20px' }}>
          <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Quick Links</h3>
          <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
            <li><a href="/about" style={{ color: '#fff', textDecoration: 'none', display: 'block', margin: '5px 0' }}>About Us</a></li>
            <li><a href="/services" style={{ color: '#fff', textDecoration: 'none', display: 'block', margin: '5px 0' }}>Services</a></li>
            <li><a href="/tools" style={{ color: '#fff', textDecoration: 'none', display: 'block', margin: '5px 0' }}>Tools</a></li>
            <li><a href="/blog" style={{ color: '#fff', textDecoration: 'none', display: 'block', margin: '5px 0' }}>Blog</a></li>
            <li><a href="/contact" style={{ color: '#fff', textDecoration: 'none', display: 'block', margin: '5px 0' }}>Contact Us</a></li>
          </ul>
        </div>

        {/* Social Media Links */}
        <div style={{ flex: '1', minWidth: '200px', marginBottom: '20px' }}>
          <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Follow Us</h3>
          <div style={{ display: 'flex', gap: '15px' }}>
            <a
              href="https://www.linkedin.com/in/calfin"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#0073e6',
                textDecoration: 'none',
                fontSize: '20px',
              }}
            >
              LinkedIn
            </a>
            <a
              href="https://twitter.com/calfin"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#0073e6',
                textDecoration: 'none',
                fontSize: '20px',
              }}
            >
              Twitter
            </a>
            <a
              href="https://youtube.com/financewithcalfin"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#0073e6',
                textDecoration: 'none',
                fontSize: '20px',
              }}
            >
              Youtube
            </a>
            <a
              href="https://www.instagram.com/financewithcalfin"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#0073e6',
                textDecoration: 'none',
                fontSize: '20px',
              }}
            >
              Instagram
            </a>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div style={{ textAlign: 'center', borderTop: '1px solid #444', paddingTop: '20px', marginTop: '20px' }}>
        <p style={{ margin: 0 }}>© 2024 CALFIN Technologies Private Limited. All Rights Reserved.</p>
        <p style={{ margin: 0 }}>Designed and Developed by CALFIN Team</p>
      </div>
    </footer>
  );
};

export default Footer;
